// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3st4D","colMin":"styles_colMin___ToDO"};